<template>
	<div class="wrap_body">
			<div class="right_con">
					<div class="goods_main" v-loading="isLoading">
						<div class="select_wrap">
							<el-input class="w290" v-model="searchData.title" placeholder="请输入商品标题" clearable>
								<p slot="prefix" class="label_title">商品标题</p>
							</el-input>
							<el-input class="w290 ml8" v-model="searchData.source_product_id" placeholder="请输入商品ID" clearable>
								<p slot="prefix" class="label_title">商品ID</p>
							</el-input>
							<el-button plain size="small" @click="getList">查询</el-button>
							<el-button plain size="small" @click="resetSearch">重置</el-button>
						</div>
						<div class="tabs_wrap">
							<p class="tab" :class="state==0?'active':''" @click="bindSate(0)">全部</p>
							<p class="tab" :class="state==100?'active':''" @click="bindSate(100)">待处理</p>
							<p class="tab" :class="state==200?'active':''" @click="bindSate(200)">成功</p>
							<p class="tab" :class="state==-10?'active':''" @click="bindSate(-10)">失败</p>
						</div>
						<div class="totals_btn">
							<p class="totals">共{{page_data.total}}条</p>
							<el-button plain size="small" @click="refresh()">刷新</el-button>
						</div>
						<div class="list_title">
							<el-table
									:header-row-style="{background:'#f9f9f9', color:'#666', 'line-hight':'50px', 'height': '50px','text-align':'center'}"
							    :data="list"
									row-key="id"
									v-loading="isLoading" 
							    style="width: 100%">
									<el-table-column
									  prop="title"
									  label="商品信息"
									  width="500">
										<template slot-scope="scope">
											<div class="product-info">
												<el-image class="coverimg" fit="contain" :src="scope.row.pic">
													<div slot="error" class="image-slot">
														<i class="el-icon-picture-outline"></i>
													</div>
												</el-image>
												<div class="name-wrap">
													<div class="name">{{scope.row.title}}</div>
													<div class="id">ID:{{scope.row.source_product_id}}</div>
												</div>
											</div>
										</template>
									</el-table-column>
									<el-table-column
									  prop="source_web_text"
									  label="平台"
										width="200"
										align="center">
									</el-table-column>
							    <el-table-column
							      prop="scope"
							      label="状态"
							      width="200">
										<template slot-scope="scope">
												<el-tag type="warning" size="small" effect="plain" v-if="scope.row.status==100">{{scope.row.status_text}}</el-tag>
												<el-tag type="success" size="small" effect="plain" v-if="scope.row.status==200">{{scope.row.status_text}}</el-tag>
												<el-tag type="danger" size="small" effect="plain" v-if="scope.row.status==-10">{{scope.row.status_text}}</el-tag>
										</template>
							    </el-table-column>
									<el-table-column
									  prop="error"
									  label="失败原因"
									  width="300">
									</el-table-column>
									<el-table-column
									  prop="scope"
									  label="链接">
										<template slot-scope="scope">
											<p class="opts" @click="openLink(scope.row.source_product_url)">访问</p>
											<p style="margin-left: 10px;" class="opts" @click="bindCopy(scope.row.source_product_url)">复制</p>
										</template>
									</el-table-column>
							  </el-table>
						</div>
					</div>
					<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getList" />
				</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import { mapActions,mapState,mapMutations } from "vuex";
	import common from '@/assets/js/utils/common.js'
	import Pagination from '../../components/pagination/pagination';
	export default { 
		name: "productQueue",
		components:{
			Pagination
		},
		props: {
			pid:{
				type:Number,
				default:0
			},
			status:{
				type: Number,
				default:0
			},
			show: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				isLoading: false,
				searchData:{},
				state:0,
				list:[],
				page_data: {
					limit: 10,
					page: 1,
					total:0,
				},
			
				
			}
		},
		created() {
			this.state = this.status
			this.getList()
			console.log(this.state)
		},
		watch:{
			show(val) {
				if(val){
					this.state = this.status
					this.searchData = {}
					this.refresh()
				}
			}
		},
		methods: {
			...mapActions({
				getProductQueueList:"ucenter/getProductQueueList",
			}),
			//获取任务列表
			getList(showLoading = true){
				if(showLoading) this.isLoading = true
				let param = {limit:this.page_data.limit,page:this.page_data.page,status:this.state,pid:this.pid}
				Object.assign(param, this.searchData)
				// console.log(param)
				this.getProductQueueList({data:param,success:(res)=>{
					if(res.code===200){
						// console.log('get list',res.data.data)
						this.list = res.data.data
						this.page_data.total = res.data.total
					} else {
						this.$message({message: res.msg,type: 'error',});
					}
					this.isLoading = false
				}})
			},
			//切换任务状态
			bindSate(e){
				this.state = e
				this.getList()
			},
			//跳转授权
			openLink(url){
				window.open(url, '_blank')
			},
			//刷新列表
			refresh(){
				this.page_data.page = 1
				this.list = []
				this.getList()
			},
			//重置搜索
			resetSearch(){
				this.searchData = {}
				this.getList()
			},
			//复制
			bindCopy(text){
				var str = ''
				var input = document.createElement("input"); // 创建input对象
				input.value = text; // 设置复制内容
				document.body.appendChild(input); // 添加临时实例
				input.select(); // 选择实例内容
				document.execCommand("Copy"); // 执行复制
				document.body.removeChild(input); // 删除临时实例
				this.$message({
					message: '复制成功',
					type: 'success'
				});
				
			},
		}

	}
</script>

<style scoped>
	.wrap .wrap_body{display: flex;flex-direction: column;}
	.ucenter_main{padding: 28px 0 40px;display: flex;justify-content: space-between;flex: 1;min-height: 500px;}
	.right_con{width: 100%;background: #fff;}
	.goods_main{padding: 0 40px 0;}
	.select_wrap{margin-top: 24px;display: flex;flex-wrap: wrap;}
	.select_wrap .mr{margin-right: 15px;}
	.select_wrap .w290{width: 290px;margin-top: 14px;position: relative;}
	.select_wrap .cate-label{position: absolute;left: 5px;z-index: 1;}
	.el-cascader{line-height: 34px;}
	.select_wrap .label_title{width: 76px;height: 100%;font-size: 12px;color: #999;display: flex;align-items: center;padding-left: 6px;}
	.tabs_wrap{width: 100%;height: 60px;border-bottom: 1px solid #eee;display: flex;}
	.tabs_wrap .tab{height: 100%;padding: 30px 16px 0;position: relative;line-height: 1;cursor: pointer;font-size: 14px;color: #666;box-sizing: border-box;}
	.tabs_wrap .tab.active{font-weight: bold;color: var(--red);}
	.tabs_wrap .tab.active::after{content: '';width: 100%;height: 3px;background: var(--red);position: absolute;left: 0;bottom: 0;z-index: 2;}
	.totals_btn{margin-top: 14px;display: flex;align-items: center;}
	.totals_btn .totals{font-size: 12px;color: #333;padding-right: 16px;margin-right: 16px;line-height: 1;border-right: 1px solid #ccc;}
	
	.list_title{margin-top: 10px;}
	.list_title .status{width: 80px;display: flex;justify-content: flex-start;align-items: center;}
	.list_title .status::before{content: '';width: 8px;height: 8px;border-radius: 50%;margin-right: 6px;}
	.list_title .status.sales::before{background: #0ea11f;}
	.list_title .status.xiajia::before{background: #ccc;}
	.list_title .status.fail::before{background: var(--red);}
	.list_title .status.fail{color: var(--red);}
	.list_title .time{width: 60px;line-height: 16px;margin: 0 20px;}
	.list_title .guanlian{color: #1966ff;cursor: pointer;}
	.list_title .guanlian:hover{text-decoration: underline;}
	.list_title .opts{color: var(--red);cursor: pointer;margin-top: 6px;display:inline-block;}
	.list_title .opts:hover{text-decoration: underline;}
	
	.header-row{background-color: #f9f9f9;}
	.el-table .warning-row {background: oldlace;}
	.el-table .success-row {background: #f0f9eb;}
	
	.product-info{display: flex;align-items: center;justify-content: space-between;width: 480px;}
	.product-info .coverimg{width: 60px;height: 60px;}
  /deep/.image-slot{width: 60px;height: 60px;display: flex !important;align-items: center;justify-content: center;display: block;font-size:26px;}
	.product-info .name-wrap{width: 400px;margin-left: 15px;font-size:14px;}
	.product-info .name-wrap .name{width: 400px;display:-webkit-box;-webkit-box-orient:vertical; -webkit-line-clamp:2; text-overflow:ellipsis;overflow: hidden;}
	.product-info .name-wrap .id{width: 400px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
	
	.opts_wrap{padding-top: 14px;}
	.opts_wrap .opts_line{margin-top: 30px;display: flex;align-items: center;}
	.opts_line .txt{width: 110px;text-align: right;font-size: 14px;}
	.opts_line .con{flex: 1;width: 0;margin-left: 22px;display: flex;align-items: center;}
	.opts_line .con .t{font-size: 14px;color: var(--red);text-decoration: underline;cursor: pointer;}
	.opts_wrap .btn_wrap{margin: 40px auto 0 auto;display: flex;align-items: center;justify-content: center;}
	.opts_wrap .btn_wrap .btn{width: 80px;height: 34px;border-radius: 4px;display: flex;justify-content: center;align-items: center;cursor: pointer;box-sizing: border-box;font-size: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(1){background: var(--red);color: #fff;margin-right: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(2){background: #fff;color: #333;border: 1px solid #ddd;margin-right: 14px;}
	.ml8{margin-left: 8px;}
	.w100{width: 100%;}
	</style>
	<style>
	
	.select_wrap .el-button{margin-top: 14px;margin-left:10px;}
	.el-input--prefix .el-input__inner,.el-cascader .el-input .el-input__inner{padding-left: 76px;height: 34px;line-height: 34px;}
	.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus{border-color: var(--red);}
	.el-select-dropdown__item.selected,.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{color: var(--red);}
	.el-input--prefix .el-input__inner:focus{border-color: var(--red);}
	.el-input__prefix, .el-input__suffix{display: flex;align-items: center;}
	.el-button{color: #333;border-color: #ddd;}
	.el-button--small{padding: 7px 15px;}
	.el-checkbox{color: #666;display: flex;align-items: center;}
	.el-checkbox__inner{border-color: #ddd;width: 16px;height: 16px;}
	.el-checkbox__input{display: flex;}
	.el-checkbox__label{font-size: 12px;line-height: 1;}
	.el-checkbox__inner::after{height: 9px;left: 5px;}
	.el-checkbox__input.is-indeterminate .el-checkbox__inner::before{height: 4px;}
	.mr10{margin-right: 10px;}
	/*red border color*/
	.el-button.is-plain:focus, .el-button.is-plain:hover ,.el-checkbox__inner:hover ,.el-checkbox__input.is-focus .el-checkbox__inner,.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{border-color: var(--red);}
	
	/*red color*/ 
	.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked+.el-checkbox__label, .el-pager li.active ,.el-pagination button:hover ,.el-pager li:hover{color: var(--red);}
	
	/*red background color*/
	.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color: var(--red);}
	
	.el-button:focus, .el-button:hover{border-color: var(--red);color: var(--red);background:#fff;}
	.el-button--primary{background: var(--red) !important;color: #fff !important;border-color: #fff;}
	.el-button--primary:focus, .el-button:hover{border-color: var(--red);}
	.el-loading-spinner .el-loading-text{color:var(--red);}
	.el-loading-spinner .path{stroke: var(--red);}
	
	.el-table th.el-table__cell{background-color: unset;}
	.el-table th.el-table__cell>.cell{padding-left: 14px;padding-right: 14px;}
</style>
